import BaseUi from '../baseUi';
import SystemUIInterface from './systemUIInterface';
import eControllerTypes from '../../controllers/system/eControllerTypes';
import {
  ControllerHonesty,
  ControllerTournaments,
  ControllerNotifications,
  ControllerTournamentsStartScreen,
  ControllerModalTournamentEnd,
  ControllerSidebar,
  ControllerRoundsHistory,
  ControllerWinLimits,
  ControllerGameSettings,
  ControllerBugReport,
  ControllerFeedback,
  ControllerRealityCheck,
  ControllerBugReportPreloaderButton,
  ControllerTournamentsUpcomingScreen,
  ControllerInfoPanel,
  ControllerRules
} from '../../controllers';
import UserAgentDetector from '../../../utils/UserAgentDetector';

export default class BaseSystemUi extends BaseUi {
  constructor(props) {
    super(props);

    this._config = {
      sidebar: {},
      ...this._config,
    };

    this._eControllersClasses = {
      [this.controllerTypes.ECT_HONESTY]: ControllerHonesty,
      [this.controllerTypes.ECT_TOURNAMENTS]: ControllerTournaments,
      [this.controllerTypes.ECT_TOURNAMENTS_START_SCREEN]: ControllerTournamentsStartScreen,
      [this.controllerTypes.ECT_MODAL_TOURNAMENT_END]: ControllerModalTournamentEnd,
      [this.controllerTypes.ECT_NOTIFICATIONS]: ControllerNotifications,
      [this.controllerTypes.ECT_SIDEBAR]: ControllerSidebar,
      [this.controllerTypes.ECT_ROUNDS_HISTORY]: ControllerRoundsHistory,
      [this.controllerTypes.ECT_TOURNAMENTS_UPCOMING_SCREEN]: ControllerTournamentsUpcomingScreen,
      [this.controllerTypes.ECT_WIN_LIMITS]: ControllerWinLimits,
      [this.controllerTypes.ECT_GAME_SETTINGS]: ControllerGameSettings,
      [this.controllerTypes.ECT_FEEDBACK]: ControllerFeedback,
      [this.controllerTypes.ECT_BUG_REPORT]: ControllerBugReport,
      [this.controllerTypes.ECT_BUG_REPORT_PRELOADER_BUTTON]: ControllerBugReportPreloaderButton,
      [this.controllerTypes.ECT_REALITY_CHECK]: ControllerRealityCheck,
      [this.controllerTypes.ECT_INFO_PANEL]: ControllerInfoPanel,
      [this.controllerTypes.ECT_RULES]: ControllerRules,
    };

    this._excludedControllerTypes.add(this.controllerTypes.ECT_BUG_REPORT_PRELOADER_BUTTON);
    this._currentOrientation = '';

    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this._onResize, this
    );

    this.scaleData = window.OPWrapperService.ScaleManager && window.OPWrapperService.ScaleManager.currentData ?
      window.OPWrapperService.ScaleManager.currentData :
      {
        innerWidth: visualViewport.width,
        innerHeight: visualViewport.height,
        orientation: visualViewport.width < visualViewport.height && UserAgentDetector.isMobile.any ? 'V' : 'H',
        isPortrait: visualViewport.width < visualViewport.height && UserAgentDetector.isMobile.any,
        isLandscape: !(visualViewport.width < visualViewport.height && UserAgentDetector.isMobile.any),
      }
  }

  hide() {
    throw new Error('System ui cannot be hidden');
  }

  _onResize(scaleData) {
    const { orientation } = scaleData;
    if (this._currentOrientation !== orientation) {
      this._currentOrientation = orientation;
      this._setupTheme();
    }
    this.scaleData = scaleData;
  }

  _checkConfig() {
  }

  _initInterface() {
    return new SystemUIInterface(this);
  }

  _setupRoot() {
    this.root.setAttribute('id', 'root-system-ui');
    this.root.classList.add('system-ui-container');
  }

  _setupTheme() {
    super._setupTheme();

    if (this._config.theme && this._currentOrientation) {
      const currentTheme = this._config.theme[this._currentOrientation];
      const { blacked_out } = currentTheme;

      if (blacked_out) {
        this.root.classList.add('blacked-out');
      } else {
        this.root.classList.remove('blacked-out');
      }
    }
  }

  _createInterfaceContainer() {
    const interfaceContainer = document.createElement('div');
    interfaceContainer.setAttribute('id', 'system-interface-container');
    this.root.append(interfaceContainer);
    return interfaceContainer;
  }

  _initController(key) {
    super._initController(key);

    if (this._controllers[key]) {
      this._controllers[key].scaleData = { scaleData: this._scaleData, rootScale: 1 };
    }
  }

  _afterControllersInit() {
    const controllerSidebar = this.controllers[this.controllerTypes.ECT_SIDEBAR];
    controllerSidebar.config = { buttons: this._config.sidebar.buttons || [] };

    this._addExtraControllersListeners();
  }

  _addExtraControllersListeners() {
  }

  _addGoogleCaptcha() {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${this.googleCaptchaToken}`;
    script.id = 'g-recaptcha-init-script';
    document.body.appendChild(script);
  }

  get controllersIdPrefix() {
    return 'system_ui';
  }

  get controllerTypes() {
    return eControllerTypes;
  }

  set partnerConfig(config) {
    this._partnerConfig = config;
    this._checkConfig();
  }

  set theme(config) {
    this._config.theme = config;
    this._setupTheme();
  }

  set scaleData(data) {
    this._scaleData = data;
    for (const key in this.controllers) {
      const controller = this.controllers[key];
      controller.scaleData = { scaleData: this._scaleData, rootScale: 1 };
    }
  }

  get googleCaptchaToken() {
    return '6Lc_JHgqAAAAAPEKTAnzb1hCRYHDtRkjEU8qMa0j';
  }
}
